__webpack_require__.p = "https://yuanxuxu-oidc-test.na.excavator.whs.amazon.dev/";